<div class="padded">
  <div *ngFor="let item of errors" class="alert alert-danger alert-dismissible">
    <strong class="me-1" *ngIf="item.title">{{item.title}}</strong>
    <span [innerHTML]="item.text" [ngClass]="{'me-3': item.dismissible}"></span>
    <button *ngIf="item.dismissible" type="button" style='font-size: x-small' class="btn-close btn-close-white " (click)="dismiss('error', item)" aria-label="Close">
    </button>
  </div>

  <div *ngFor="let item of warnings" class="alert alert-warning alert-dismissible">
    <strong class="me-1" *ngIf="item.title">{{item.title}}</strong>
    <span [innerHTML]="item.text" [ngClass]="{'me-3': item.dismissible}"></span>
    <button *ngIf="item.dismissible" type="button" style='font-size: x-small' class="btn-close btn-close-white " (click)="dismiss('warning', item)" aria-label="Close">
    </button>
  </div>

  <div *ngFor="let item of infos" class="alert alert-info alert-dismissible">
    <strong class="me-1" *ngIf="item.title">{{item.title}}</strong>
    <span [innerHTML]="item.text" [ngClass]="{'me-3': item.dismissible}"></span>
    <button *ngIf="item.dismissible" type="button" style='font-size: x-small' class="btn-close btn-close-white " (click)="dismiss('info', item)" aria-label="Close">
    </button>
  </div>

  <div *ngFor="let item of successes" class="alert alert-success alert-dismissible">
    <strong class="me-1" *ngIf="item.title">{{item.title}}</strong>
    <span [innerHTML]="item.text" [ngClass]="{'me-3': item.dismissible}"></span>
    <button *ngIf="item.dismissible" type="button" style='font-size: x-small' class="btn-close " (click)="dismiss('success', item)" aria-label="Close">
    </button>
  </div>

</div>